module.exports = __webpack_public_path__ + "static/media/vision.31491286.svg";